import { DataTable, Heading, Loader } from "@/components";
import { Input } from "@/components/ui";
import { Search } from "lucide-react";
import useProjectOverview from "./useProjectOverview";

const ProjectOverview = () => {
  const {
    globalFilter,
    setGlobalFilter,
    columns,
    projectList,
    isProjectListLoading,
  } = useProjectOverview();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Project Overview" />
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
        </div>
      </div>

      {/* Responsive Table */}
      {isProjectListLoading ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={(projectList?.data || [])?.sort(
              (a: any, b: any) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime(),
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
          />
        </>
      )}
    </div>
  );
};

export default ProjectOverview;
